import { defineMessages } from 'react-intl';

export const messageMessages = defineMessages({
	sender__agent: {
		id: 'sender.agent',
		defaultMessage: 'Human Agent',
		description: 'Name used on message sender for human agent',
	},
	sender__system: {
		id: 'sender.system',
		defaultMessage: 'Virtual Agent',
		description: 'Name used on message sender for system(m3)',
	},
	sender__user: {
		id: 'sender.user',
		defaultMessage: 'Customer',
		description: 'Name used on message sender for user',
	},
	message__retry_send: {
		id: 'message.retry_send',
		defaultMessage: 'Message not sent. Click to retry send...',
		description:
			'"Retry" message displayed under chat messages if message got error while sending',
	},
	message__invalid_message: {
		id: 'message.invalid_message',
		defaultMessage: 'Invalid message',
		description:
			'Error message displayed in chat message balloon when the chat receive an unsupported/broken message',
	},
	message__sending: {
		id: 'message.sending',
		defaultMessage: 'Sending...',
		description:
			'"Sending" message displayed under chat messages while chat await confirmation from server',
	},
	message__download: {
		id: 'message.download',
		defaultMessage: 'Download',
		description:
			'Download message displayed in message when the chat receives a media message',
	},
	message__closed__content: {
		id: 'message.close.content',
		defaultMessage:
			'Thank you for using our service.<br/>We hope to see you again soon!',
		description: 'Content text displayed in the close screen',
	},
});
